/*
 * File: ProviderSelectField.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the Provider select field on the main new charge page
 */
import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import Users from "services/users/Users";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import FilledInput from "@material-ui/core/FilledInput";
import InputLabel from "@material-ui/core/InputLabel";
import PropTypes from "prop-types";
import { StoreContext } from "utils/useStore";

const styles = () => ({
  selectField: {
    borderRadius: "4px !important;"
  },
  formControl: {
    width: "100%"
  }
});

class ProviderSelectField extends React.Component {
  state = {
    providers: []
  };

  static contextType = StoreContext;
  componentDidMount() {
    this.populateProviders();
  }

  async populateProviders() {
    let providers = await this.context.getStore(Users).forSelect("providers");
    this.setState({ providers: providers });
  }

  handleChange = event => {
    let newProviderId = this.getProviderId(event.target.value);
    this.props.chargeModel.changeField("providerId", newProviderId);
    this.props.checkForError();
  };

  getProviderId = providerName => {
    var matchingProviderObject = this.state.providers.find(provider => {
      return provider.name === providerName;
    });
    return Number(matchingProviderObject.id);
  };

  getProviderName = providerId => {
    let { providers } = this.state;
    if (!providers || providers.length === 0) return "";
    var matchingProviderObject = providers.find(provider => {
      return Number(provider.id) === providerId;
    });
    if (matchingProviderObject) return matchingProviderObject.name;
    else return "";
  };

  render() {
    const { chargeModel, classes } = this.props;
    const { providers } = this.state;
    const errorMessage = this.props.errorMessage;
    let providerName = this.getProviderName(chargeModel.providerId);
    let menuItems = providers.map(provider => {
      return (
        <MenuItem value={provider.name} key={provider.id}>
          {provider.name}
        </MenuItem>
      );
    });

    return (
      <div>
        <FormControl variant="filled" className={classes.formControl}>
          <InputLabel error={errorMessage !== ""}>{"Provider"}</InputLabel>
          <Select
            id="providerId"
            fullWidth={true}
            className={classes.selectField}
            disableUnderline={true}
            error={errorMessage !== ""}
            value={providerName}
            onChange={this.handleChange}
            input={<FilledInput name="providerId" id="providerId" />}
          >
            {menuItems}
          </Select>
          <FormHelperText error={errorMessage !== ""}>
            {errorMessage}
          </FormHelperText>
        </FormControl>
      </div>
    );
  }
}

ProviderSelectField.propTypes = {
  chargeModel: PropTypes.object.isRequired,
  checkForError: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  errorMessage: PropTypes.string
};

export default withStyles(styles)(ProviderSelectField);
